import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PlanningPanelModel} from "../../models/planning-panel.model";
import {PlanningViewSettingsModel} from "../../models/planning-view-settings.model";
import {
  PlanningGroupedJobsListPanelComponent
} from "../../angular/components/planning-grouped-jobs-list-panel/planning-grouped-jobs-list-panel.component";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {
  PlanningDraftRoutesSortingDialogComponent
} from "../../angular/components/planning-draft-routes-sorting-dialog/planning-draft-routes-sorting-dialog.component";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {PlanningRouteModel} from "../../models/planning-route.model";
import {
  PlanningRoutesHelperService,
  PlanningRoutesFilterContext
} from "../../services/planning-routes-helper.service";
import {PlanningViewMode} from "../../types/planning-view-mode.enum";
import {PlanningRouteStatusEnum} from "../../types/planning-route-status.enum";

export class PlanningDraftRoutesPanelComponent implements IController {

  index: any;
  panel: PlanningPanelModel;
  panels: PlanningPanelModel[];
  routes: PlanningRouteModel[];
  resources: any[];
  jobs: any[];
  draft?: any;
  selectedIds: string[];
  selectedJobIds: string[];
  selectedJobs: any[];
  visibleIds: any[];
  isGroupedRoutes: boolean;
  isLoading: boolean;
  highlightedActivity?: any;
  settings: PlanningViewSettingsModel;
  itemElementSize: string;
  onSettingsChange: Function;
  onSelectRoutes: Function;
  onSelectJobs: Function;
  onVisibleRoutesChange: Function;
  onRouteSelect: Function;
  onLockRouteChange: Function;
  onChangeRouteResource: Function;
  onEditResourceAllocation: Function;
  onMoveActivity: Function;
  onAddStopsToRoute: Function;
  onDispatch: Function;
  onPrint: Function;
  onPrintLoadingSheet: Function;
  onToggleGroupedRoutes: Function;
  onDelete: Function;
  onFeedback: Function;
  onReoptimize: Function;
  onEditPickingTime: Function;
  onViewJob: Function;
  onPanelChange: Function;
  onCreateRouteByJobs: Function;
  onUpdateRouteByJobs: Function;
  onAddJobsToDraft: Function;
  onRemoveJobs: Function;
  onMoveToLeftovers: Function;
  onToggleObligateTimeWindow: Function;
  onToggleLockJobs: Function;
  onDrillDown: Function;
  onNewPanelDrillDown: Function;
  viewMode: PlanningViewMode;

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public planningViewMode: typeof PlanningViewMode = PlanningViewMode;
  public filteredRoutes: any;
  public selectedRoute?: any;
  public sortBy: string;
  public sortByType: any;
  public isSelectedRouteRunning: boolean = false;
  public scrollOffset: number = 0;
  public selectedRoutes: any[] = [];
  public includeFilters: SiteFiltersType[] = [
    SiteFiltersType.branchIds,
    SiteFiltersType.vehicleTypes,
    SiteFiltersType.agentSkills,
    SiteFiltersType.serviceAreaIds,
    SiteFiltersType.labels,
    SiteFiltersType.resourceIds,
    SiteFiltersType.statuses,
    SiteFiltersType.isSynced
  ];
  public dropdownFilters: any;
  public filtersQueryMap: any;
  public pageName: string = 'planning-routes';

  /* @ngInject */
  constructor(private panelService: PanelService, private $timeout, private planningRoutesHelperService: PlanningRoutesHelperService) {
  }

  $onInit() {
    if (!this.draft) {
      this.panel = {};
    }

    this.planningRoutesHelperService.initFilters(this.panel);
    this._setDropdownFilters();
    this.sortBy = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortBy;
    this.sortByType = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortByType;
    this._setFilteredRoutes();
    this._setSelectedRoute();
    this._setSelectedRoutes();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.panel && !changes.panel.isFirstChange()) {
      const currentPanel = changes.panel?.currentValue,
        previousPanel = changes.panel?.previousValue;

      this._setDropdownFilters();

      if (currentPanel.selectedRouteId !== previousPanel.selectedRouteId) {
        this._setSelectedRoute();
      }

      if ((currentPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortBy !== previousPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortBy) ||
        (currentPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortByType !== previousPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortByType)) {
        this.sortBy = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortBy;
        this.sortByType = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortByType;

        if (!!this.sortBy && !!this.sortByType) {
          this._sortFilteredRoutes();
        }
      }
    }

    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedRoutes();
    }

    if (changes.resources) {
      this._setFiltersQueryMap();
    }

    if (changes.routes && !changes.routes.isFirstChange()) {
      this._setFilteredRoutes();
      this._setSelectedRoute();
      this._setSelectedRoutes();
    }
  }

  onBeforeEditResourceAllocation(route: any, event: any) {
    const resourceId = route.resource?.id;
    const resource = this.resources.find(r => r.id === resourceId);
    this.onEditResourceAllocation({resource: resource, routeId: route.id, event: event});
  }

  onToggleSelectAll() {
    if (this.selectedIds?.length > 0 && this.selectedIds.length === this.filteredRoutes?.length) {
      this.onSelectRoutes({ids: []});
    } else {
      this.onSelectRoutes({ids: this.filteredRoutes?.map(r => r.id) || []});
    }
  }

  onToggleSort(event) {
    const panel = this.panelService.open(PlanningDraftRoutesSortingDialogComponent, event, {
      sortBy: this.sortBy,
      sortByType: this.sortByType,
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      width: 130,
      height: 205
    })

    if (panel) {
      panel.instance.onSortTypeChange.subscribe(data => {
        const panelCopy = angular.copy(this.panel);
        panelCopy.tabsFilterConfig[this.panel.selectedTabIndex].sortBy = data.sortBy;
        panelCopy.tabsFilterConfig[this.panel.selectedTabIndex].sortByType = data.sortByType;
        this.onPanelChange({panel: panelCopy});
      });
    }
  }

  onQueryChanged(query) {
    this.panel.tabsFilterConfig[this.panel.selectedTabIndex].queryString = query;
    this._setFilteredRoutes();
    this.onPanelChange({panel: this.panel});
  }

  onRoutesFiltersChange(filters) {
    Object.assign(this.panel.tabsFilterConfig[this.panel.selectedTabIndex], _.pick(filters, this.includeFilters));

    this._setDropdownFilters();
    this._setFilteredRoutes();
    this.onPanelChange({panel: this.panel});
  }

  onChangeRouteFilter(value: boolean | undefined) {
    this.panel.tabsFilterConfig[this.panel.selectedTabIndex].jobsInRouteQuery = value;

    this.onPanelChange({panel: this.panel});
  }

  onMoveActivityAction(payload: { jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, pickupIndex?: number, destinationIndex?: number, allowSkillsMismatch?: boolean }) {
    this.onMoveActivity({
      jobIds: payload.jobIds,
      fromRouteId: payload.fromRouteId,
      toRouteId: payload.toRouteId,
      fromOrderedIds: payload.fromOrderedIds,
      toOrderedIds: payload.toOrderedIds,
      pickupIndex: payload.pickupIndex,
      destinationIndex: payload.destinationIndex,
      allowSkillsMismatch: payload.allowSkillsMismatch
    })
  }

  storeScrollOffset(offset: number) {
    this.scrollOffset = offset;
  }

  private _setDropdownFilters() {
    this.dropdownFilters = _.pick(this.panel.tabsFilterConfig[this.panel.selectedTabIndex], this.includeFilters);
  }

  private _setFiltersQueryMap() {
    this.filtersQueryMap = {
      statusOptions: Object.values(PlanningRouteStatusEnum),
      resourceOptions: _.map(this.resources, (resource) => ({
        id: resource.id,
        name: _.get(resource, 'source') === 'AgentSchedule'
          ? _.get(resource, 'agentName', '---')
          : (_.get(resource, 'allocationName') || _.get(resource, 'vehicleName', '---'))
      }))
    };
  }

  private _setFilteredRoutes() {
    const filterContext: PlanningRoutesFilterContext = {
      filterConfig: this.panel.tabsFilterConfig[this.panel.selectedTabIndex]
    };

    this.$timeout(0).then(() => {
      this.filteredRoutes = _.filter(this.routes, (r) => {
        return this.planningRoutesHelperService.filterRouteByFilters(r, filterContext);
      });
      if (!!this.sortBy && !!this.sortByType) {
        this._sortFilteredRoutes();
      }
    });
  }

  private _setSelectedRoutes() {
    this.selectedRoutes = this.routes.filter(route => this.selectedIds.includes(route.id));
  }

  private _setSelectedRoute() {
    this.selectedRoute = this.panel.selectedRouteId ?
      this.routes.find((r) => {
        return r.id === this.panel.selectedRouteId
      }) :
      undefined;

    this.isSelectedRouteRunning = this.selectedRoute ?
      (this.selectedRoute.actionProcess?.running && (new Date().getTime() < this.selectedRoute.actionProcess?.expirationDate)) :
      undefined;
  }

  private _sortFilteredRoutes() {
    this.filteredRoutes = this.planningRoutesHelperService.sortFilteredRoutes(this.filteredRoutes, this.sortBy, this.sortByType);
    this.$timeout(() => {}, 0);
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftRoutesPanel', {
    bindings: {
      index: '<',
      panel: '<',
      panels: '<',
      routes: '<',
      resources: '<',
      jobs: '<',
      draft: '<?',
      selectedIds: '<',
      selectedJobIds: '<',
      selectedJobs: '<',
      visibleIds: '<',
      settings: '<',
      highlightedActivity: '<?',
      isGroupedRoutes: '<',
      isLoading: '<',
      itemElementSize: '<?',
      viewMode: '<',
      onSettingsChange: '&',
      onRoutesSettingsChange: '&',
      onSelectRoutes: '&',
      onSelectJobs: '&',
      onVisibleRoutesChange: '&',
      onRouteSelect: '&',
      onLockRouteChange: '&',
      onChangeRouteResource: '&',
      onEditResourceAllocation: '&',
      onMoveActivity: '&',
      onAddStopsToRoute: '&',
      onDispatch: '&',
      onReoptimize: '&',
      onEditPickingTime: '&',
      onPreAssignAgent: '&',
      onViewJob: '&',
      onPrint: '&',
      onPrintLoadingSheet: '&',
      onToggleGroupedRoutes: '&',
      onDelete: '&',
      onFeedback: '&',
      onPanelChange: '&',
      onCreateRouteByJobs: '&',
      onUpdateRouteByJobs: '&',
      onAddJobsToDraft: '&',
      onRemoveJobs: '&',
      onMoveToLeftovers: '&',
      onDrillDown: '&',
      onToggleObligateTimeWindow: '&',
      onToggleLockJobs: '&',
      onNewPanelDrillDown: '&'
    },
    template: require('./planning-draft-routes-panel.html').default,
    controller: PlanningDraftRoutesPanelComponent
  });
